module.exports = __webpack_public_path__ + "img/LogoDashboard-20.5ef48dea.svg";